import { Link } from "react-router-dom";
import { footerLinks } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-16 lg:px-10">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-flex items-center">
              <img
                src="https://public.readdy.ai/ai/img_res/132a126f-a939-4e58-86ac-0cd20e4c35f6.png"
                alt="DJT EV Power Tech · Green Steel logo"
                title="DJT EV Power Tech · Green Steel"
                className="h-16 w-auto object-contain md:h-24"
              />
            </Link>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-200">
              Green steel from green hydrogen. A modular pilot producing 50 tonnes of green iron (HBI) a day —
              water and renewable power in, near-zero-carbon iron out.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-sm">
              <a
                href="mailto:sales@djtevretrofitting.in"
                className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3.5 py-2 text-background-100 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-mail-line" /> sales@djtevretrofitting.in
              </a>
              <a
                href="tel:18005700229"
                className="inline-flex items-center gap-2 rounded-md bg-background-50/10 px-3.5 py-2 text-background-100 transition-colors hover:bg-background-50/20"
              >
                <i className="ri-phone-line" /> 1800 570 0229
              </a>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              <a href="#solutions" className="hover:text-accent-300">
                Solutions
              </a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {footerLinks.solutions.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-background-200 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              <a href="#about" className="hover:text-accent-300">
                Company
              </a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {footerLinks.company.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-background-200 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              <a href="#products" className="hover:text-accent-300">
                Resources
              </a>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              {footerLinks.resources.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-background-200 transition-colors hover:text-background-50">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-background-50">
              Visit us
            </h4>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              1st Floor, Siri Sampada Arcade
              <br />
              102/3, Khajaguda–Nanakramguda Road
              <br />
              Gachibowli, Hyderabad
              <br />
              Telangana 500104
            </p>
            <div className="mt-4 flex gap-2">
              {["ri-linkedin-fill", "ri-twitter-x-fill", "ri-youtube-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="social link"
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-50/15 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} DJT EV Power Tech · Green Steel. All rights reserved.</p>
          <div className="flex flex-wrap gap-5">
            <a href="#contact" className="transition-colors hover:text-background-50">
              Privacy Policy
            </a>
            <a href="#contact" className="transition-colors hover:text-background-50">
              Terms of Service
            </a>
            <a href="#impact" className="transition-colors hover:text-background-50">
              Sustainability Report
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}